import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import FormRadioGroup from '../form/FormRadioGroup';
import QuestionHeader from './QuestionHeader';
import SubmissionLocationMap from './SubmissionLocationMap';
import { Typography } from '@material-ui/core';

const SubmissionLocationChoice = ({ name, number, questionText, answers, readonly, isOptional }) => (
  <div className="box">
    <div className="col-sm-12">
      <QuestionHeader name={questionText} number={number} />
      {isOptional && <Typography variant="caption" color="textSecondary">Odpowiedź nie jest wymagana</Typography>}
      <div>
        <Field
          name={`${name}.selectedAnswersIds[0]`}
          component={FormRadioGroup}
          values={answers.map(answer => ({ value: answer.id, name: `${answer.answerText} (${answer.address}, ${answer.city})` }))}
          disabled={readonly}
        />
      </div>
      <div style={{marginTop: 16}}>
        <SubmissionLocationMap
          loadingElement={<div style={{ height: '100%', }} />}
          containerElement={<div style={{ height: 350 }} />}
          mapElement={<div style={{ height: '100%' }} />}
          markers={answers.filter(p => p.lat && p.lng)}
        />
      </div>
    </div>
  </div>
);

SubmissionLocationChoice.propTypes = {
  name: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  answers: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  isOptional: PropTypes.bool,
};

export default SubmissionLocationChoice;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/SubmissionLocationChoice.js